import i18n from 'i18next';

export default function getFormattedPrice(value, currency, locale = i18n.language) {
    return Intl.NumberFormat(locale.replace('_', '-'), {
        style: 'currency',
        currency: currency
    }).format(value);
}
